/**
 * ============================================================================
 * BRANDME - THEME ENGINE
 * ============================================================================
 * 
 * Dynamic theme engine for BrandMe.
 * Automatically generates 70+ CSS variables from user colors.
 * 
 * @module theme-engine
 */

// Export all utilities
export * from './color-utils';
export * from './theme-generator';
export { ThemeEngine } from './ThemeEngine';

// Create and export global instance
import { ThemeEngine } from './ThemeEngine';

/**
 * Global theme engine instance
 * To use in your app: import { themeEngine } from '@/libs/theme-engine'
 */
export const themeEngine = new ThemeEngine();

/**
 * Vue plugin to integrate the theme engine
 * Usage: Vue.use(ThemePlugin)
 */
export const ThemePlugin = {
  install(Vue) {
    // Add to Vue instance
    Vue.prototype.$theme = themeEngine;
    
    // Initialize on install
    themeEngine.init();
  }
};
